import {CreateDeliveryNoteRequest} from '../models/delivery.note/CreateDeliveryNote.request';
import {UpdateDeliveryNotesRequest} from '../models/delivery.note/UpdateDeliveryNotes.request';

export namespace DeliveryNoteActions {
  export class GetDeliveryNotes {
    static readonly type = '[Delivery Note api] Get Delivery Notes';

    constructor(public id: string, public force: boolean = false) {
    }
  }

  export class CreateDeliveryNote {
    static readonly type = '[Delivery Note api] Create Delivery Note';

    constructor(public jobId: string, public request: CreateDeliveryNoteRequest) {
    }
  }

  export class UpdateDeliveryNotes {
    static readonly type = '[Delivery Note api] Update Delivery Notes';

    constructor(public jobId: string, public request: UpdateDeliveryNotesRequest) {
    }
  }

  export class DeleteDeliveryNote {
    static readonly type = '[Delivery Note api] Delete Delivery Note';

    constructor(public jobId: string, public id: string) {
    }
  }
}
